import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import GridIncreaseCell from './grid-increase-graph';
import GridDeclineCell from './grid-decline-graph';
import GridNameCell from './grid-name-cell';
import HoverContainer from './grid-hover-container';

function GridPopCell(props) {
  const {
    item,
    rowClass,
  } = props;

  return (
    <React.Fragment>
      <div className={`pop-change ${rowClass}`}>{item.formattedValue}</div>
      <div className={`pop-change-percentage ${rowClass}`}>{item.formattedPercentageValue}</div>
      <div className={`pop-range ${rowClass}`}>{item.fromTo}</div>
    </React.Fragment>
  );
}

GridPopCell.defaultProps = {
};
GridPopCell.propTypes = {
  item: PropTypes.shape({
    formattedValue: PropTypes.string.isRequired,
    formattedPercentageValue: PropTypes.string.isRequired,
    fromTo: PropTypes.string.isRequired,
  }).isRequired,
  rowClass: PropTypes.string.isRequired,
};

function GridRow(props) {
  const {
    item,
    index,
    i18n,
    newI18n,
    dateRange,
    metric,
  } = props;

  const rowClass = useMemo(() => `conversion-goals-grid-row-${index + 1}`, [index]);
  const isIncrease = useMemo(() => item.increaseSpace < 100, [item.increaseSpace]);

  return (
    <React.Fragment>
      <GridNameCell item={item} i18n={i18n} rowClass={rowClass} {...props} />
      <GridDeclineCell item={item} rowClass={rowClass} />
      <GridIncreaseCell item={item} rowClass={rowClass} />
      <GridPopCell item={item} rowClass={rowClass} />
      <HoverContainer
        isGrid
        isIncrease={isIncrease}
        item={item}
        rowClass={rowClass}
        newI18n={newI18n}
        metric={metric}
        dateRange={dateRange}
      />
      <HoverContainer
        isIncrease={isIncrease}
        item={item}
        rowClass={rowClass}
        newI18n={newI18n}
        metric={metric}
        dateRange={dateRange}
      />
    </React.Fragment>
  );
}

GridRow.defaultProps = {
};

GridRow.propTypes = {
  item: PropTypes.shape({
    increaseSpace: PropTypes.number.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  i18n: PropTypes.shape({}).isRequired,
  newI18n: PropTypes.shape({}).isRequired,
  dateRange: PropTypes.shape({}).isRequired,
  metric: PropTypes.string.isRequired,
};

export default GridRow;
